import CategoryTierGroupAPI from '@/api/categoryTierGroup.api'

const state = {
  tierGroups: [],
  selectedRow: {}
}

const actions = {
  async list({ commit }) {
    const response = await CategoryTierGroupAPI.list()
    const data = Array.isArray(response.data) ? response.data : []
    commit('SET_TIER_GROUPS', data)
  },

  async findOne({ commit }, id) {
    const response = await CategoryTierGroupAPI.findOne(id)
    commit('SET_SELECTED_ROW', response.data)
    return response.data
  },

  clearSelected({ commit }) {
    commit('SET_SELECTED_ROW', null)
  },

  async create(_, payload) {
    const response = await CategoryTierGroupAPI.create(payload)
    return response.data
  },

  async update(_, { id, ...payload }) {
    const response = await CategoryTierGroupAPI.patch(id, payload)
    return response.data
  },

  async remove(_, id) {
    await CategoryTierGroupAPI.delete(id)
  },

  async addCategory(_, { id, categoryId, minRpc, maxRpc, position }) {
    const response = await CategoryTierGroupAPI.addCategory(id, {
      categoryId,
      minRpc,
      maxRpc,
      position
    })
    return response.data
  },

  async removeCategory(_, { id, categoryId }) {
    const response = await CategoryTierGroupAPI.removeCategory(id, categoryId)
    return response.data
  },

  async reorderCategories(_, { id, orderedCategoryIds }) {
    const response = await CategoryTierGroupAPI.reorderCategories(id, orderedCategoryIds)
    return response.data
  },

  async updateRpcBounds(_, { id, categoryId, minRpc, maxRpc }) {
    const response = await CategoryTierGroupAPI.updateRpcBounds(id, categoryId, {
      minRpc,
      maxRpc
    })
    return response.data
  }
}

const mutations = {
  SET_TIER_GROUPS(state, tierGroups) {
    state.tierGroups = tierGroups
  },
  SET_SELECTED_ROW(state, tierGroup) {
    state.selectedRow = tierGroup || {}
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
